<div class="full-width" fxLayout="column">
  <!-- Products Sources Section -->
  <div class="full-width" fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span class="body-1-default"
            [matBadge]="importConfig.transactionSources.length == 0 ? getTransactionSourceValues().length : importConfig.transactionSources.length"
            matBadgeOverlap="false">
        Products Sources
      </span>

      <mat-button-toggle-group
        [value]="isTransactionSourcesAllMode() ? 'all' : 'custom'"
        (change)="setTransactionSourcesMode($event.value === 'all')"
        class="custom-date-button-toggle">
        <mat-button-toggle value="all">ALL</mat-button-toggle>
        <mat-button-toggle value="custom">CUSTOM</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="options-grid"
         [class.disabled]="isTransactionSourcesAllMode()"
         fxLayout="row wrap"
         fxLayoutGap="10px">
      <mat-checkbox
        *ngFor="let source of getTransactionSourceValues()"
        [checked]="isTransactionSourceSelected(source)"
        [disabled]="isTransactionSourcesAllMode()"
        (change)="toggleTransactionSource(source)"
        color="primary"
        class="option-checkbox">
        {{ formatEnumValue(source) }}
      </mat-checkbox>
    </div>
  </div>

  <!-- Product Link Status Section -->
  <div class="full-width" fxLayout="column" fxLayoutGap="15px" fxFlexOffset="25px">
    <span class="body-1-default">Product Link Status</span>
    <mat-radio-group
      [value]="importConfig.linkStatus"
      (change)="selectProductLinkStatus($event.value)"
      fxLayout="row"
      fxLayoutGap="20px">
      <mat-radio-button
        *ngFor="let type of getProductLinkStatusValues()"
        [value]="type"
        color="primary">
        {{ formatEnumValue(type) }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Import Agreement Type Section -->
  <div class="full-width" fxLayout="column" fxLayoutGap="15px" fxFlexOffset="25px">
    <span class="body-1-default">Import Agreement Type</span>
    <mat-radio-group
      [value]="importConfig.importAgreementType"
      (change)="selectImportAgreementType($event.value)"
      fxLayout="row"
      fxLayoutGap="20px">
      <mat-radio-button
        *ngFor="let type of getImportAgreementTypeValues()"
        [value]="type"
        color="primary">
        {{ formatEnumValue(type) }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Payment Configurations Section -->
  <div class="full-width" fxLayout="column" fxLayoutGap="15px" fxFlexOffset="25px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span class="body-1-default" [matBadge]="configCount" matBadgeOverlap="false">
        Payment Configurations
      </span>

      <mat-button-toggle-group
        [value]="isPaymentConfigsAllMode() ? 'all' : 'custom'"
        (change)="setPaymentConfigsMode($event.value === 'all')"
        class="custom-date-button-toggle">
        <mat-button-toggle value="all">ALL</mat-button-toggle>
        <mat-button-toggle value="custom">CUSTOM</mat-button-toggle>
      </mat-button-toggle-group>
    </div>


    <div *ngIf="!isPaymentConfigsAllMode()" fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div></div>
        <div fxLayout="row" fxLayoutGap="10px">
          <button class="button-action" mat-flat-button
                  [disabled]="areAllIncluded"
                  (click)="selectAllInclude()">
            <div class="button-text">Include All</div>
          </button>
          <button class="button-action" mat-flat-button
                  [disabled]="areAllExcluded"
                  (click)="selectAllExclude()">
            <div class="button-text">Exclude All</div>
          </button>
          <button class="button-action-cancel" mat-flat-button
                  (click)="unselectAll()">
            <div class="button-text">Clear</div>
          </button>
        </div>
      </div>

      <!-- Single Configurations Section as Table -->
      <div
        *ngIf="importConfig.importAgreementType === ImportAgreementType.MASTER && getSingleConfigsDataSource().data.length > 0"
        fxLayout="column" fxLayoutGap="15px">
        <span class="body-3-default">Single Lease Payment Configs</span>

        <div fxLayout="column">
          <table mat-table class="custom-table" [dataSource]="getSingleConfigsDataSource()">
            <ng-container matColumnDef="table-label">
              <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="displayColumns.length">
                Single Lease Configurations
              </th>
            </ng-container>

            <ng-container matColumnDef="retailerId">
              <th mat-header-cell *matHeaderCellDef>Retailer ID</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ element.retailerId || 'Unknown' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="retailerCompanyName">
              <th mat-header-cell *matHeaderCellDef>Company Name</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ element.retailerCompanyName || 'Unknown' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef>Start Date</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ dateUtils.displayShortDate(element.startDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ dateUtils.displayShortDate(element.endDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="include">
              <th mat-header-cell *matHeaderCellDef>Include</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                <mat-checkbox
                  [checked]="isPaymentConfigIncluded(element.uuid!)"
                  (click)="$event.stopPropagation()"
                  (change)="togglePaymentConfigInclude(element.uuid!)"
                  color="primary">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="exclude">
              <th mat-header-cell *matHeaderCellDef>Exclude</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                <mat-checkbox
                  [checked]="isPaymentConfigExcluded(element.uuid!)"
                  (click)="$event.stopPropagation()"
                  (change)="togglePaymentConfigExclude(element.uuid!)"
                  color="warn">
                </mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
            <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayColumns"></tr>
            <tr *matRowDef="let row; columns: displayColumns;"
                class="custom-table-row"
                mat-row>
            </tr>
          </table>
        </div>
      </div>

      <!-- Master Shared Configurations Table -->
      <div *ngIf="importConfig.importAgreementType === ImportAgreementType.MASTER && getSharedConfigsDataSource().data.length > 0"
           fxLayout="column" fxLayoutGap="15px">
        <span class="body-3-default">Shared Lease Payment Configs</span>

        <div fxLayout="column">
          <table mat-table class="custom-table" [dataSource]="getSharedConfigsDataSource()">
            <ng-container matColumnDef="table-label">
              <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="displayColumns.length">
                Shared Lease Configurations
              </th>
            </ng-container>

            <ng-container matColumnDef="retailerId">
              <th *matHeaderCellDef mat-header-cell>Retailer ID</th>
              <td *matCellDef="let element" class="custom-table-cell" mat-cell>
                {{ element.retailerId || 'N/A' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="retailerCompanyName">
              <th mat-header-cell *matHeaderCellDef>Company Name</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ element.retailerCompanyName || 'Unknown' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef>Start Date</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ dateUtils.displayShortDate(element.startDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ dateUtils.displayShortDate(element.endDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="include">
              <th mat-header-cell *matHeaderCellDef>Include</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                <mat-checkbox
                  [checked]="isPaymentConfigIncluded(element.uuid!)"
                  (click)="$event.stopPropagation()"
                  (change)="togglePaymentConfigInclude(element.uuid!)"
                  color="primary">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="exclude">
              <th mat-header-cell *matHeaderCellDef>Exclude</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                <mat-checkbox
                  [checked]="isPaymentConfigExcluded(element.uuid!)"
                  (click)="$event.stopPropagation()"
                  (change)="togglePaymentConfigExclude(element.uuid!)"
                  color="warn">
                </mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
            <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayColumns"></tr>
            <tr *matRowDef="let row; columns: displayColumns;"
                class="custom-table-row"
                mat-row>
            </tr>
          </table>
        </div>
      </div>

      <!-- Master Offering Configurations Table -->
      <div *ngIf="importConfig.importAgreementType === ImportAgreementType.MASTER && getOfferingConfigsDataSource().data.length > 0"
           fxLayout="column"  fxLayoutGap="15px">
        <span class="body-3-default">Offering Payment Configs</span>

        <div fxLayout="column">
          <table mat-table class="custom-table" [dataSource]="getOfferingConfigsDataSource()">
            <ng-container matColumnDef="table-label">
              <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="offeringDisplayColumns.length">
                Offering Configurations
              </th>
            </ng-container>

            <ng-container matColumnDef="uuid">
              <th *matHeaderCellDef mat-header-cell>Config ID</th>
              <td *matCellDef="let element" class="custom-table-cell" mat-cell>
                {{ utils.displayUuid(element.uuid) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="displayName">
              <th mat-header-cell *matHeaderCellDef>Domain Prefix</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ parseMainSourceConfig(element.transactionSourceConfig!).displayName || parseMainSourceConfig(element.transactionSourceConfig!).domainPrefix || 'Unknown' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef>Start Date</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ dateUtils.displayShortDate(element.startDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                {{ dateUtils.displayShortDate(element.endDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="include">
              <th mat-header-cell *matHeaderCellDef>Include</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                <mat-checkbox
                  [checked]="isPaymentConfigIncluded(element.uuid!)"
                  (click)="$event.stopPropagation()"
                  (change)="togglePaymentConfigInclude(element.uuid!)"
                  color="primary">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="exclude">
              <th mat-header-cell *matHeaderCellDef>Exclude</th>
              <td mat-cell class="custom-table-cell" *matCellDef="let element">
                <mat-checkbox
                  [checked]="isPaymentConfigExcluded(element.uuid!)"
                  (click)="$event.stopPropagation()"
                  (change)="togglePaymentConfigExclude(element.uuid!)"
                  color="warn">
                </mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
            <tr mat-header-row class="custom-table-header" *matHeaderRowDef="offeringDisplayColumns"></tr>
            <tr *matRowDef="let row; columns: offeringDisplayColumns;"
                class="custom-table-row"
                mat-row>
            </tr>
          </table>
        </div>
      </div>


      <!-- Sub-lease configurations (grouped by parent with separate tables) -->
      <div *ngIf="importConfig.importAgreementType === ImportAgreementType.SUB_LEASE" fxLayout="column" fxLayoutGap="25px">

        <!-- Shared Configurations Section -->
        <div *ngIf="getSharedConfigsByType('shared').length > 0" fxLayout="column" fxLayoutGap="20px">
          <span class="body-3-default">Shared Lease Sub-Configurations</span>

          <!-- Table for each parent in shared configs -->
          <div *ngFor="let group of getSharedConfigsByType('shared')"
               fxLayout="column"  fxLayoutGap="15px">
            <div fxLayout="column">
              <table mat-table class="custom-table" [dataSource]="createParentGroupDataSource(group.parentName, 'shared')">
                <ng-container matColumnDef="table-label">
                  <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="displayColumns.length">
                    {{ group.parentName }}
                  </th>
                </ng-container>

                <ng-container matColumnDef="retailerId">
                  <th *matHeaderCellDef mat-header-cell>Retailer ID</th>
                  <td *matCellDef="let element" class="custom-table-cell" mat-cell>
                    {{ element.retailerId || 'N/A' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="retailerCompanyName">
                  <th mat-header-cell *matHeaderCellDef>Company Name</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    {{ element.retailerCompanyName || 'Unknown' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                  <th mat-header-cell *matHeaderCellDef>Start Date</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    {{ dateUtils.displayShortDate(element.startDate) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef>End Date</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    {{ dateUtils.displayShortDate(element.endDate) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="include">
                  <th mat-header-cell *matHeaderCellDef>Include</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    <mat-checkbox
                      [checked]="isPaymentConfigIncluded(element.uuid!)"
                      (click)="$event.stopPropagation()"
                      (change)="togglePaymentConfigInclude(element.uuid!)"
                      color="primary">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="exclude">
                  <th mat-header-cell *matHeaderCellDef>Exclude</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    <mat-checkbox
                      [checked]="isPaymentConfigExcluded(element.uuid!)"
                      (click)="$event.stopPropagation()"
                      (change)="togglePaymentConfigExclude(element.uuid!)"
                      color="warn">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayColumns"></tr>
                <tr *matRowDef="let row; columns: displayColumns;"
                    class="custom-table-row"
                    mat-row>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <!-- Offering Configurations Section -->
        <div *ngIf="getSharedConfigsByType('offering').length > 0" fxLayout="column" fxLayoutGap="10px">
          <span class="body-3-default">Offering Sub-Configurations</span>

          <!-- Table for each parent in offering configs -->
          <div *ngFor="let group of getSharedConfigsByType('offering')"
               fxLayout="column" fxLayoutGap="15px">
            <div fxLayout="column">
              <table mat-table class="custom-table" [dataSource]="createParentGroupDataSource(group.parentName, 'offering')">
                <ng-container matColumnDef="table-label">
                  <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="displayColumns.length">
                    {{ group.parentName }}
                  </th>
                </ng-container>

                <ng-container matColumnDef="retailerId">
                  <th *matHeaderCellDef mat-header-cell>Config ID</th>
                  <td *matCellDef="let element" class="custom-table-cell" mat-cell>
                    {{ element.retailerCompanyName || 'N/A' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="retailerCompanyName">
                  <th mat-header-cell *matHeaderCellDef>Company Name</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    {{ element.retailerCompanyName || 'Unknown' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                  <th mat-header-cell *matHeaderCellDef>Start Date</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    {{ dateUtils.displayShortDate(element.startDate) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef>End Date</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    {{ dateUtils.displayShortDate(element.endDate) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="include">
                  <th mat-header-cell *matHeaderCellDef>Include</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    <mat-checkbox
                      [checked]="isPaymentConfigIncluded(element.uuid!)"
                      (click)="$event.stopPropagation()"
                      (change)="togglePaymentConfigInclude(element.uuid!)"
                      color="primary">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="exclude">
                  <th mat-header-cell *matHeaderCellDef>Exclude</th>
                  <td mat-cell class="custom-table-cell" *matCellDef="let element">
                    <mat-checkbox
                      [checked]="isPaymentConfigExcluded(element.uuid!)"
                      (click)="$event.stopPropagation()"
                      (change)="togglePaymentConfigExclude(element.uuid!)"
                      color="warn">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayColumns"></tr>
                <tr *matRowDef="let row; columns: displayColumns;"
                    class="custom-table-row"
                    mat-row>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
